webpackJsonp([29],{

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                "+_vm._s(_vm.rentalLabel)+" ‐ Self Drive Rate\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('h2',[_vm._v("\n                  "+_vm._s(_vm.rentalLabel)+" ‐ Self Drive Rate\n                  "),_vm._m(1)]),_vm._v(" "),_c('p',[_vm._v("Set all rental rate.")])])])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.masterClassName))]),_vm._v(" "),_c('td',{staticClass:"text-center",class:{ 'sts-danger': !item.rateItemCount }},[_vm._v("\n                  "+_vm._s(item.rateItemCount === 0 ? "N/A" : item.rateItemCount)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(
                        _vm.isAllowToCreate || _vm.isAllowToUpdate || _vm.isAllowToDelete
                      )?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.manageRate(item)}}},[_c('span',[_vm._v("Manage")])]):_vm._e()])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25",staticStyle:{"padding-top":"15px","padding-bottom":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.items.length)+" Records")])])])])])]),_vm._v(" "),(_vm.selectedMasterClass)?_c('div',{ref:"vuemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-sell",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("\n                "+_vm._s(_vm.rentalLabel)+" ‐ Self Drive Rate ("+_vm._s(_vm.selectedMasterClass.masterClassName)+")\n              ")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-30"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                      This form has errors\n                    ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Rate Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.type.$error,
                          },attrs:{"placeholder":"Select type","label":"label","options":_vm.types,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.text; }},on:{"input":_vm.changeUseDuration},model:{value:(_vm.model.type),callback:function ($$v) {_vm.$set(_vm.model, "type", $$v)},expression:"model.type"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.type.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Type is required")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Group Zone(s)")]),_vm._v(" "),_c('multiselect',{class:{
                            'field-error':
                              _vm.isSubmitted && !_vm.$v.model.zoneGroupIds.required,
                          },attrs:{"options":_vm.groups,"multiple":true,"close-on-select":false,"placeholder":"Select group zone(s)","label":"label","track-by":"id"},model:{value:(_vm.model.zoneGroupIds),callback:function ($$v) {_vm.$set(_vm.model, "zoneGroupIds", $$v)},expression:"model.zoneGroupIds"}}),_vm._v(" "),(
                            _vm.isSubmitted && !_vm.$v.model.zoneGroupIds.required
                          )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                          Group zone(s) is required\n                        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Minimum Hire Duration")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.minimumHireDuration),expression:"model.minimumHireDuration"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.model.minimumHireDuration.$error,
                          },attrs:{"type":"number","placeholder":"Number"},domProps:{"value":(_vm.model.minimumHireDuration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "minimumHireDuration", $event.target.value)}}}),_vm._v(" "),(
                            _vm.isSubmitted && _vm.$v.model.minimumHireDuration.$error
                          )?_c('div',[(!_vm.$v.model.minimumHireDuration.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Minimum Hire Duration is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.minimumHireDuration.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Minimum Hire Duration is\n                            "+_vm._s(_vm.$v.model.minimumHireDuration.$params.minValue
                                .min))]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.isRentalRateType(this.model.type))?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Pricing Unit (hours)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.duration),expression:"model.duration"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.duration.$error,
                          },attrs:{"type":"number","placeholder":"Number"},domProps:{"value":(_vm.model.duration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "duration", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.duration.$error)?_c('div',[(!_vm.$v.model.duration.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Duration is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.duration.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min duration is\n                            "+_vm._s(_vm.$v.model.duration.$params.minValue.min))]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v(" Currency ")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.currency.$error,
                          },attrs:{"placeholder":"Select currency","label":"text","options":_vm.currencies,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model.currency),callback:function ($$v) {_vm.$set(_vm.model, "currency", $$v)},expression:"model.currency"}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.currency.$error)?_c('div',[(!_vm.$v.model.currency.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Currency is required")]):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v(" Rate ")]),_vm._v(" "),_c('currency-input',{staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.rate.$error,
                          },attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":false,"currency":null},model:{value:(_vm.model.rate),callback:function ($$v) {_vm.$set(_vm.model, "rate", $$v)},expression:"model.rate"}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.rate.$error)?_c('div',[(!_vm.$v.model.rate.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Rate is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.rate.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min rate is\n                            "+_vm._s(_vm.$v.model.rate.$params.minValue.min))]):_vm._e()]):_vm._e()],1),_vm._v(" "),(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                          Reset\n                        ")]),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Create\n                        ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                          Update\n                        ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive table-accordion"},[_c('table',{staticClass:"table table-hover"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.rates),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(_vm.humanize(item.type))+"\n                              ")]),_vm._v(" "),_c('td',[(
                                    item.zoneGroups &&
                                    item.zoneGroups.length > 0
                                  )?_vm._l((item.zoneGroups),function(zone,idxZone){return _c('p',{key:idxZone,staticClass:"mb-0"},[_vm._v("\n                                    "+_vm._s(zone.name)+"\n                                  ")])}):[_vm._v(" - ")]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                "+_vm._s(item.minimumHireDuration
                                    ? item.minimumHireDuration
                                    : "-")+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                                "+_vm._s(_vm.isRentalRateType(item.type)
                                    ? item.duration
                                    : "N/A")+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                "+_vm._s(item.currency)+"\n                                "+_vm._s(item.rate.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                  }))+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                    "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                  ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper button-action-wrapper-new"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-edit",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}},[_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 15h3l8.5-8.5a1.5 1.5 0 0 0-3-3L9 12v3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 5l3 3"}})])])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M400 145.49L366.51 112L256 222.51L145.49 112L112 145.49L222.51 256L112 366.51L145.49 400L256 289.49L366.51 400L400 366.51L289.49 256L400 145.49z","fill":"currentColor"}})])]):_vm._e()])])])}),0)])])])])])])])])])])])]):_vm._e(),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Booker Tariff")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"ic-price-calculator"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Class")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Combinations")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Group Zone(s)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                                Minimum Hire Duration\n                              ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                                Pricing Unit (hours)\n                              ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Rate")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RentalSelfDriveRate_vue__ = __webpack_require__(775);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_772e6230_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RentalSelfDriveRate_vue__ = __webpack_require__(1012);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RentalSelfDriveRate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_772e6230_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RentalSelfDriveRate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(498), __esModule: true };

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(25);
module.exports = __webpack_require__(499);


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(58);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(242);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(495);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(512), __esModule: true };

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(1).Object.entries;


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(514)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(6);
var getKeys = __webpack_require__(19);
var toIObject = __webpack_require__(10);
var isEnum = __webpack_require__(27).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/zones";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list" + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list/active").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllGroups: function getAllGroups() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list/group").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getZonesByGroupId: function getZonesByGroupId(params) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/by-group?" + params)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getLocation: function getLocation(group, id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var url, queries;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              url = endpoint + "/location";
              queries = [];


              if (id) {
                queries.push("id=" + id);
              }

              if (group) {
                queries.push("group=" + group);
              }

              if (queries.length > 0) {
                url += "?" + queries.join("&");
              }

              _context5.next = 7;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 7:
              return _context5.abrupt("return", _context5.sent);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  create: function create(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  update: function update(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  delete: function _delete(id) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/exchangeRates';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(providerRate) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + providerRate)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllProviders: function getAllProviders() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/providers').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getMapping: function getMapping() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/item/map').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getCurrencySelection: function getCurrencySelection() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/currency').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  createMapping: function createMapping(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/map', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateMapping: function updateMapping(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/map', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  updateRate: function updateRate(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/rate', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/selling/RentalRates';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getRates: function getRates(masterClassId, isSelfDrive) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/rate?class=' + masterClassId + '&selfDrive=' + isSelfDrive)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getBuyingRange: function getBuyingRange(masterClassId, isSelfDrive) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/range?class=' + masterClassId + '&selfDrive=' + isSelfDrive)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getCommon: function getCommon(isSelfDrive) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/common?selfDrive=' + isSelfDrive)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  create: function create(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  update: function update(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  delete: function _delete(id) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_master_zone_zoneService_js__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_master_exchangeRate_exchangeRateService_js__ = __webpack_require__(529);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_7__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      formatter: null,
      types: [],
      rentalLabel: null,
      allPermissions: [],
      selectedMasterClass: null,
      isUpdate: false,
      isItemHasBeenModified: false,
      itemToBeDeleted: null,
      items: [],
      rates: [],
      model: {},
      rateTagData: [],
      companies: [],
      isLoading: false,
      msg: "Please wait",
      currencies: [],
      groups: [],
      useDuration: false,
      openedRow: ""
    };
  },
  validations: function validations() {
    if (this.useDuration) {
      return {
        model: {
          type: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
          zoneGroupIds: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
          currency: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
          minimumHireDuration: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minValue"])(0) },
          duration: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minValue"])(0) },
          rate: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minValue"])(0) }
        }
      };
    } else {
      return {
        model: {
          type: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
          zoneGroupIds: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
          minimumHireDuration: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minValue"])(0) },
          currency: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
          rate: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minValue"])(0) }
        }
      };
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.getAllGroups();

            case 3:
              _context.next = 5;
              return _this.$store.dispatch("setting/getAllPublic");

            case 5:
              publicSettings = _context.sent;

              _this.rentalLabel = _this.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");

              _context.next = 9;
              return _this.$store.dispatch("user/getProfile");

            case 9:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 19;
                break;
              }

              _context.next = 15;
              return _this.getAll();

            case 15:
              _context.next = 17;
              return _this.getCommon();

            case 17:
              _context.next = 19;
              return _this.getCurrency();

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-rental-selfdrive-link");
  },

  methods: {
    changeUseDuration: function changeUseDuration() {
      var rateType = this.model.type.toLowerCase();
      if (rateType === "perhour" || rateType === "perday" || rateType === "perweek" || rateType === "permonth") {
        this.useDuration = true;
      } else {
        this.useDuration = false;
      }
    },
    getAllGroups: function getAllGroups() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var groups;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_master_zone_zoneService_js__["a" /* default */].getAllGroups();

              case 2:
                groups = _context2.sent;


                if (groups) {
                  _this2.groups = groups.map(function (val) {
                    return { label: val.name, id: val.id };
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getCurrency: function getCurrency() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__services_master_exchangeRate_exchangeRateService_js__["a" /* default */].getCurrencySelection();

              case 2:
                response = _context3.sent;

                if (response && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response).length > 0) {
                  _this3.currencies = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(response).map(function (_ref) {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                        key = _ref2[0],
                        value = _ref2[1];

                    return {
                      value: key,
                      text: value
                    };
                  });
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    resetModel: function resetModel() {
      this.model = {};
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal: function openModal(object) {
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
      $(this.$refs.vuemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal: function closeModal() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.resetModel();
                _this4.resetValidations();
                $(_this4.$refs.vuemodal).modal("hide");

                if (!_this4.isItemHasBeenModified) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 6;
                return _this4.getAll();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    bindModel: function bindModel(item) {
      item.zoneGroupIds = item.zoneGroups.map(function (val) {
        return {
          id: val.id,
          label: val.name
        };
      });
      this.isUpdate = true;
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
    },
    reset: function reset() {
      this.isUpdate = false;
      this.resetValidations();
      this.model = {};
    },
    getAll: function getAll() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__["a" /* default */].getAll("?selfDrive=true");

              case 4:
                response = _context5.sent;

                _this5.items = response.data;
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context5.prev = 11;

                _this5.isLoading = false;
                return _context5.finish(11);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 8, 11, 14]]);
      }))();
    },
    getCommon: function getCommon() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var common, i, item;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__["a" /* default */].getCommon(true);

              case 2:
                common = _context6.sent;

                _this6.types = common.types;

                for (i = 0; i < _this6.types.length; i++) {
                  item = _this6.types[i];

                  item.label = _this6.humanize(item.text);
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    getRates: function getRates(masterClassId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__["a" /* default */].getRates(masterClassId, true);

              case 2:
                _this7.rates = _context7.sent;

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    manageRate: function manageRate(item) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this8.isLoading = true;
                _this8.isItemHasBeenModified = false;
                _this8.selectedMasterClass = item;
                _context8.next = 6;
                return _this8.getRates(item.masterClassId);

              case 6:
                _this8.openModal({});
                _this8.isUpdate = false;

              case 8:
                _context8.prev = 8;

                _this8.isLoading = false;
                return _context8.finish(8);

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0,, 8, 11]]);
      }))();
    },
    submit: function submit() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var groupZoneTemp, index;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this9.isSubmitted = true;
                _this9.$v.model.$touch();

                if (!_this9.$v.model.$error) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt("return");

              case 4:
                groupZoneTemp = _this9.model.zoneGroupIds;
                _context9.prev = 5;

                _this9.isLoading = true;
                _this9.model.zoneGroupIds = _this9.model.zoneGroupIds.map(function (val) {
                  return val.id;
                });
                _this9.model.rate = parseFloat(_this9.model.rate);
                _this9.model.duration = _this9.isRentalRateType(_this9.model.type) ? parseInt(_this9.model.duration) : 1;

                if (!_this9.isUpdate) {
                  _context9.next = 16;
                  break;
                }

                _context9.next = 13;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__["a" /* default */].update(_this9.model);

              case 13:
                _this9.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context9.next = 21;
                break;

              case 16:
                _this9.model.isSelfDrive = true;
                _this9.model.masterClassId = _this9.selectedMasterClass.masterClassId;
                _context9.next = 20;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__["a" /* default */].create(_this9.model);

              case 20:
                _this9.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 21:
                _this9.reset();
                _context9.next = 24;
                return _this9.getRates(_this9.selectedMasterClass.masterClassId);

              case 24:
                _this9.isItemHasBeenModified = true;
                _context9.next = 31;
                break;

              case 27:
                _context9.prev = 27;
                _context9.t0 = _context9["catch"](5);

                _this9.model.zoneGroupIds = groupZoneTemp;
                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this9.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 31:
                _context9.prev = 31;

                _this9.isLoading = false;
                return _context9.finish(31);

              case 34:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[5, 27, 31, 34]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this10.isLoading = true;
                item.zoneGroupIds = item.zoneGroups.map(function (val) {
                  return val.id;
                });
                delete item.zoneGroups;
                _context10.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__["a" /* default */].update(item);

              case 6:
                _this10.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context10.next = 9;
                return _this10.getRates(_this10.selectedMasterClass.masterClassId);

              case 9:
                _this10.isItemHasBeenModified = true;
                _context10.next = 15;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](0);

                if (_context10.t0.errors) {
                  for (index = 0; index < _context10.t0.errors.length; index++) {
                    _this10.$notification.error(_context10.t0.errors[index], { title: "Error" });
                  }
                }

              case 15:
                _context10.prev = 15;

                _this10.isLoading = false;
                return _context10.finish(15);

              case 18:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[0, 12, 15, 18]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                _this11.isLoading = true;
                _context11.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_sellingTariff_sellingTariffRentalRateService_js__["a" /* default */].delete(_this11.itemToBeDeleted.id);

              case 4:
                _this11.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context11.next = 7;
                return _this11.getRates(_this11.selectedMasterClass.masterClassId);

              case 7:
                _this11.isItemHasBeenModified = true;
                _context11.next = 13;
                break;

              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](0);

                if (_context11.t0.errors) {
                  for (index = 0; index < _context11.t0.errors.length; index++) {
                    _this11.$notification.error(_context11.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context11.prev = 13;

                _this11.isLoading = false;
                setTimeout(function () {
                  $("body").addClass("modal-open");
                }, 500);
                return _context11.finish(13);

              case 17:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[0, 10, 13, 17]]);
      }))();
    },
    cancelDelete: function cancelDelete() {
      setTimeout(function () {
        $("body").addClass("modal-open");
      }, 500);
    },
    isRentalRateType: function isRentalRateType(type) {
      return type && (type === "PerHour" || type === "PerDay" || type === "PerWeek" || type === "PerMonth");
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.62cfb93ee36b8f84b20f.js